import { object, string } from "yup";

export const manageProfileValidation = object({
  first_name: string().trim().required("First name is required"),
  last_name: string().trim().required("Last name is required"),
  email: string()
    .trim()
    .email("Enter a valid email")
    .required("Email is required"),
  role: string().required("Role is required"),
});
